module.exports = __webpack_public_path__ + "img/FPT22.db73bcf6.svg";